import { useEffect, useState } from "react";
import { api, SITE_DEFAULTS } from "@/lib/api";

let cached = null;
const subs = new Set();

export function useSiteInfo() {
  const [info, setInfo] = useState(cached || SITE_DEFAULTS);

  useEffect(() => {
    if (cached) { setInfo(cached); return; }
    let mounted = true;
    api.get("/site/info").then(({ data }) => {
      cached = { ...SITE_DEFAULTS, ...data };
      if (mounted) setInfo(cached);
      subs.forEach((fn) => fn(cached));
    }).catch(() => {});
    const fn = (v) => mounted && setInfo(v);
    subs.add(fn);
    return () => { mounted = false; subs.delete(fn); };
  }, []);

  return info;
}
